import * as React from "react";
import { Link } from "components/common";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import ProviderName from "ai-management/components/ProviderName";
import SchedulingCell from "./SchedulingCell";
import WorkflowStatus from "./WorkflowStatus";
import AgentWorkflowRoutes from "../Routes";
export const WorkflowStatusCell = ({ workflow }) => {
  const { refetch } = useTableFetchContext();
  return /* @__PURE__ */ React.createElement(WorkflowStatus, { workflow, onSuccess: refetch });
};
const columnRenderers = {
  attributes: {
    title: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(Link, { to: AgentWorkflowRoutes.workflowDetails(workflow.id), onClick: (event) => event.stopPropagation() }, workflow.title),
      staticWidth: 260
    },
    disabled: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(WorkflowStatusCell, { workflow }),
      staticWidth: 120
    },
    provider: {
      renderCell: (provider) => /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider }),
      staticWidth: 130
    },
    model: {
      renderCell: (model) => /* @__PURE__ */ React.createElement(React.Fragment, null, model),
      staticWidth: 220
    },
    scheduling: {
      renderCell: (_value, workflow) => /* @__PURE__ */ React.createElement(SchedulingCell, { workflow }),
      staticWidth: 180
    }
  }
};
export default columnRenderers;
